module.exports = __webpack_public_path__ + "img/service2.16a20268.png";